// Resources
const ResourcesModule = () => import('@pages/resources/ResourcesModule')
const ResourcesIndex = () => import('@pages/resources/ResourcesIndex')
const SubResourcesIndex = () =>
    import('@pages/resources/subResources/SubResourcesIndex')

export default {
    path: 'resources',
    component: ResourcesModule,
    children: [
        {
            path: 'resources',
            component: ResourcesIndex,
            name: 'resources',
        },
        {
            path: 'sub-resources',
            component: SubResourcesIndex,
            name: 'subResources',
        },
    ],
}
